import {
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { FilterableTableApiKeys } from "./components/TableApiKeys/FilterableTableApiKeys";
import { useApiKeyActions } from "./hooks/useApiKeyActions";

export const ApiKeys: React.FC = () => {
  const actions = useApiKeyActions();

  return (
    <WSPage>
      <WSPageToolbar
        title="Developer"
        actions={[
          {
            label: "Generate new key",
            buttonKind: "Primary",
            icon: "plus",
            onClick: actions.generate
          }
        ]}
      />

      <WSList gap="2XL">
        <FilterableTableApiKeys
          onEdit={actions.edit}
          onRotate={actions.rotate}
          onDelete={actions.remove}
          onGenerate={actions.generate}
        />
      </WSList>
    </WSPage>
  );
};
